import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SolomonIslandsFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15950'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15950)'>
				<rect
					width='20'
					height='14'
					fill='url(#paint0_linear_2332_15950)'
				/>
				<g filter='url(#filter0_d_2332_15950)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 0H20L0 14V0Z'
						fill='url(#paint1_linear_2332_15950)'
					/>
				</g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M20 0L0 14H20V0Z'
					fill='#2C7442'
				/>
				<rect
					width='23.8135'
					height='16.7902'
					transform='matrix(0.834219 -0.551434 0.566962 0.823744 -1.98047 13.7939)'
					fill='#FFD646'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M1.44223 3.04387L1.57587 2.28028L1.00977 1.7395L1.7921 1.62809L2.14198 0.93335L2.49185 1.62809L3.27419 1.7395L2.70808 2.28028L2.84172 3.04387L2.14198 2.68335L1.44223 3.04387ZM6.20414 3.04387L6.33778 2.28028L5.77167 1.7395L6.55401 1.62809L6.90388 0.93335L7.25375 1.62809L8.03609 1.7395L7.46999 2.28028L7.60362 3.04387L6.90388 2.68335L6.20414 3.04387ZM6.33778 5.08028L6.20414 5.84387L6.90388 5.48335L7.60362 5.84387L7.46999 5.08028L8.03609 4.5395L7.25375 4.42809L6.90388 3.73335L6.55401 4.42809L5.77167 4.5395L6.33778 5.08028ZM2.14198 5.48335L1.44223 5.84387L1.57587 5.08028L1.00977 4.5395L1.7921 4.42809L2.14198 3.73335L2.49185 4.42809L3.27419 4.5395L2.70808 5.08028L2.84172 5.84387L2.14198 5.48335ZM3.82318 4.44387L4.52293 4.08335L5.22267 4.44387L5.08903 3.68028L5.65514 3.1395L4.8728 3.02809L4.52293 2.33335L4.17306 3.02809L3.39072 3.1395L3.95682 3.68028L3.82318 4.44387Z'
					fill='white'
				/>
			</g>
			<defs>
				<filter
					id='filter0_d_2332_15950'
					x='0'
					y='0'
					width='20'
					height='14'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_15950'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_15950'
						result='shape'
					/>
				</filter>
				<linearGradient
					id='paint0_linear_2332_15950'
					x1='0'
					y1='0'
					x2='0'
					y2='14'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#1DBE4F' />
					<stop
						offset='1'
						stopColor='#159B3F'
					/>
				</linearGradient>
				<linearGradient
					id='paint1_linear_2332_15950'
					x1='0'
					y1='0'
					x2='0'
					y2='14'
					gradientUnits='userSpaceOnUse'>
					<stop stopColor='#0660D4' />
					<stop
						offset='1'
						stopColor='#0051BB'
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default SolomonIslandsFlagIcon;
